import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TerminalList } from "../../../../../API/terminals";
import classes from "./TaskmapWizard.module.css";
import React, { useEffect, useState } from "react";

export type TerminalSelectorProps = {
  terminals: TerminalList;
  setTerminal: (machine: string) => void;
};

export function TerminalSelector({
  terminals,
  setTerminal,
}: TerminalSelectorProps): React.ReactNode {
  const { t } = useTranslation();
  const defaultTerminalId = terminals[0]?.id ?? "";
  const [selectedTerminal, setSelectedTerminal] =
    useState<string>(defaultTerminalId);

  useEffect(() => {
    if (defaultTerminalId) {
      setTerminal(defaultTerminalId);
    }
  }, [defaultTerminalId, setTerminal]);

  return (
    <div className={classes.selector}>
      <FormControl fullWidth={true}>
        <InputLabel id="select-terminal-label">
          {t("label.Terminal")}
        </InputLabel>
        <Select
          labelId="select-terminal-label"
          value={selectedTerminal}
          name="terminal"
          fullWidth={true}
          onChange={(event) => {
            const value = event.target.value as string;
            setSelectedTerminal(value);
            setTerminal(value);
          }}
        >
          {terminals.map((terminal) => (
            <MenuItem key={terminal.id} value={terminal.id}>
              {t(`terminal.${terminal.id}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
